// LexiQamus public surface pack (search + pre-search innovations landing)
import 'stylesheets/lexiqamus'
import 'stylesheets/lexiqamus_public_page'
import 'stylesheets/lexiqamus_announcements'
import '../lexiqamus_announcements'

const dismissLexiqamusFlashes = () => {
  document.querySelectorAll('.lexiqamus-flash[data-auto-dismiss]').forEach((el) => {
    setTimeout(() => el.remove(), 5000)
  })
}

const stripSidebarOpenParam = () => {
  const url = new URL(window.location.href)
  if (url.searchParams.get('sidebar') !== 'true') return
  url.searchParams.delete('sidebar')
  const query = url.searchParams.toString()
  history.replaceState(null, '', `${url.pathname}${query ? `?${query}` : ''}${url.hash}`)
}

document.addEventListener('DOMContentLoaded', dismissLexiqamusFlashes)
document.addEventListener('turbolinks:load', dismissLexiqamusFlashes)
document.addEventListener('DOMContentLoaded', stripSidebarOpenParam)
document.addEventListener('turbolinks:load', stripSidebarOpenParam)

// Homepage-only assets (no searched_text). Avoids loading innovations (~4.7 MB) on search pages.
// Static requires still land in the webpack manifest for image_pack_tag on the homepage partial.
if (document.querySelector('.lexiqamus-home-viewport')) {
  const innovationAnnouncementImages = require.context('../images/lexiqamus/innovation_announcements', false, /\.(png|jpe?g|gif|webp)$/i)
  innovationAnnouncementImages.keys().forEach(innovationAnnouncementImages)
}